export default __webpack_public_path__ + "static/watch-trailer-c2c00910d591e6a277db93aa479d176b.svg";